import { useState } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

const FixedImpressions = () => {
  const [impressions, setImpressions] = useState(100000);
  const [cpm, setCpm] = useState(2.5);
  const budget = Math.round((impressions * cpm) / 1000);

  return (
    <>
      <Box p={3} pt={1.5}>
        <Stack
          direction='row'
          gap={2}
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography>Impressions</Typography>
          <TextField
            size='small'
            type='number'
            value={impressions}
            onChange={(event) => {
              const imps = Number(event.target.value);
              if (imps >= 0) {
                setImpressions(imps);
              }
            }}
            slotProps={{
              htmlInput: {
                'aria-label': 'Impressions',
                min: 0,
                step: 1000,
              },
            }}
            sx={{ width: 200 }}
          />
        </Stack>

        <Stack
          direction='row'
          gap={2}
          alignItems='center'
          justifyContent='space-between'
          pt={3.5}
        >
          <Typography>CPM</Typography>
          <TextField
            size='small'
            type='number'
            value={cpm}
            onChange={(event) => {
              const newCpm = Number(event.target.value);
              if (newCpm >= 0 && newCpm <= 10) {
                setCpm(newCpm);
              }
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <Typography variant='body16' pr={1} color='text.secondary'>
                    $
                  </Typography>
                ),
              },
              htmlInput: {
                'aria-label': 'CPM',
                min: 0,
                max: 10,
                step: 0.01,
              },
            }}
            sx={{ width: 200 }}
          />
        </Stack>
        <Box py={1}>
          <Slider
            aria-label='CPM'
            value={cpm}
            onChange={(_event, newValue) => {
              setCpm(newValue);
            }}
            step={0.01}
            min={0}
            max={10}
            valueLabelDisplay='auto'
          />
          <Stack direction='row' justifyContent='space-between'>
            <Typography variant='body14' color='text.secondary'>
              0
            </Typography>
            <Typography variant='body14' color='text.secondary'>
              $10
            </Typography>
          </Stack>
        </Box>
      </Box>

      <Divider />

      <Box p={3}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <Box>
            <Typography variant='body2'>Budget Needed</Typography>
          </Box>

          <Typography variant='body1' fontWeight={600}>
            {new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
            }).format(budget)}
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default FixedImpressions;
